import React from 'react'
import clsx from 'clsx'
import { Divider as DividerStyles } from '@airbus/elements/elements'
import { CommonProps, PolymorphicProps } from '../helperTypes'
import { createUseStyles } from '../../lib/styling'

type Props = {
  /** If true, disable all margins */
  dense?: boolean
  /** If true, adds left/right margins  */
  inset?: boolean
  /** If true, the divider will be vertically oriented */
  vertical?: boolean
}

export type DividerProps<C extends React.ElementType> = PolymorphicProps<C, Props & CommonProps>

const useStyles = createUseStyles(DividerStyles, 'divider')

export const Divider = <C extends React.ElementType = 'hr'>(props: DividerProps<C>) => {
  const { className, component, dense = false, inset = false, vertical = false, ...rest } = props
  const classes = useStyles()
  const ComponentProp = component || 'hr'

  return (
    <ComponentProp
      className={clsx(
        className,
        classes.root,
        dense && classes._dense,
        inset && classes._inset,
        vertical && classes._vertical,
      )}
      {...rest}
    />
  )
}

export default Divider
